import React from 'react';
import { NCZIEhrExtract } from '../../../Interfaces/ncziTypes';
import EHRFolder from './EHRFolder/EHRFolder';
import EHRComposition from './EHRComposition/EHRComposition';
// @ts-ignore
import styles from './EHRExtract.module.scss';
import { FormattedDateTime } from '../../../../../Components/FormattedDate';
import Text from '../../../../../Components/Base/Text/Text';

interface Props {
	ehrExtract: NCZIEhrExtract | undefined;
}

const EHRExtract: React.FC<Props> = props => {
	const { ehrExtract } = props;

	if (!ehrExtract) {
		return <></>;
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.created}>
				<Text tx='nczi.createdAt' inline />:{' '}
				<FormattedDateTime datetime={ehrExtract.created} />
			</div>
			{ehrExtract.folders.map((folder, key) => (
				<EHRFolder folder={folder} key={key} />
			))}
			{ehrExtract.items.map((item, key) => (
				<EHRComposition item={item} key={key} />
			))}
		</div>
	);
};

export default EHRExtract;
